import { generateLocalizedRouteConfig, LocalizedRoutes } from '@/router/localizedRouting';
import { VALUATION_FUNNEL_PATH } from '@/router/routes/constants';
import { Pages } from '@/types';

const Component = () => import('@/pages/PropertyValuation');

const routes: LocalizedRoutes = {
  de: { path: VALUATION_FUNNEL_PATH['de'] },
  en: { path: VALUATION_FUNNEL_PATH['en'] },
  fr: { path: VALUATION_FUNNEL_PATH['fr'] },
  it: { path: VALUATION_FUNNEL_PATH['it'] },
};

const localizedRouteConfig = generateLocalizedRouteConfig(routes, Component, Pages.Funnel);

export default localizedRouteConfig;
